import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
export function PdfViewer({ src, height = '500px' }) {
    const componentId = useRef('miniapp-pdf-' + Math.random().toString(36).substr(2, 9));
    const initialized = useRef(false);
    useEffect(() => {
        if (!src || initialized.current)
            return;
        // The Vue pdfviewer bundle loads as a deferred module script, so it may not be
        // ready yet when the (sync-loaded) miniapp bundle mounts — poll until it appears
        var cancelled = false;
        var retryTimer = null;
        var attempts = 0;
        var MAX_ATTEMPTS = 67; // ~10s at 150ms
        var tryInit = function () {
            if (cancelled || initialized.current)
                return;
            if (typeof window.vue_pdfviewer_init !== 'function') {
                if (attempts < MAX_ATTEMPTS) {
                    attempts++;
                    retryTimer = setTimeout(tryInit, 150);
                }
                return;
            }
            try {
                window.vue_pdfviewer_init({
                    componentId: componentId.current,
                    pdfSrc: src,
                    height: '100%',
                    isPrintable: false,
                    isDownloadable: false,
                });
                initialized.current = true;
            }
            catch (e) {
                // fallback: silent
            }
        };
        tryInit();
        return () => {
            cancelled = true;
            if (retryTimer) {
                clearTimeout(retryTimer);
            }
            if (typeof window.vue_pdfviewer_destruct === 'function' && initialized.current) {
                try {
                    window.vue_pdfviewer_destruct(componentId.current);
                }
                catch (e) { /* ignore */ }
                initialized.current = false;
            }
        };
    }, [src]);
    // If source changes after init, update via setSource
    useEffect(() => {
        if (initialized.current && src && window.pdfviewer_instances) {
            var instance = window.pdfviewer_instances[componentId.current];
            if (instance) {
                instance.setSource(src);
            }
        }
    }, [src]);
    return (_jsx("div", { "data-component-id": componentId.current, style: { display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }, children: _jsx("div", { className: "ui-pdfviewer", style: { flex: 1, minHeight: 0 } }) }));
}
